import { render, staticRenderFns } from "./PastPrestigeRunsContainer.vue?vue&type=template&id=38893b62&scoped=true"
import script from "./PastPrestigeRunsContainer.vue?vue&type=script&lang=js"
export * from "./PastPrestigeRunsContainer.vue?vue&type=script&lang=js"
import style0 from "./PastPrestigeRunsContainer.vue?vue&type=style&index=0&id=38893b62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38893b62",
  null
  
)

export default component.exports